import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "question_content" }
const _hoisted_2 = { class: "preview_content" }
const _hoisted_3 = ["innerHTML"]

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import getFormData from 'get-form-data'
import AnswerItem from '../../../common/AnswerItem'
import { IQuestion, IAnswerItem } from '../../../types'
import { IAnswer } from '../types'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionContentComponent',
  props: {
    currentQuestion: {},
    currentQuestionIndex: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const store = useStore()

const answers = computed(() => store.state.Exam.answers as IAnswer[])
const submit = () => store.dispatch('Exam/submit')
const updateAnswer = (payload: { answer: any; questionId: number }) => store.dispatch('Exam/updateAnswer', payload)

const currentAnswers = computed(() => {
  return answers.value.filter((answer) => answer.q_id == props.currentQuestion.id)
})

const currentQuestionContent = computed(() => {
  return props.currentQuestion ? props.currentQuestion.body : ""
})

// Template ref for form
const answerFormRef = ref<HTMLFormElement | null>(null)

const fillValue = () => {
  const answerForm = answerFormRef.value
  if (!answerForm) return
  
  // this is async process so we should check for sure
  if (!currentAnswers.value || currentAnswers.value.length == 0 || currentAnswers.value[0].q_id != props.currentQuestion.id) {
    const textareas: any[] = answerForm.getElementsByTagName("textarea") as any
    for (let index = 0; index < textareas.length; index++) {
      const element = textareas[index]
      switch (props.currentQuestion.fieldType) {
        case "textarea":
          const CKEDITOR = (window as any).CKEDITOR
          if (CKEDITOR) {
            CKEDITOR.replace(element.id, {})
          }
          break
      }
    }
    return
  }
  const inputs: any[] = answerForm.getElementsByTagName("input") as any
  for (let index = 0; index < inputs.length; index++) {
    const element = inputs[index]
    switch (props.currentQuestion.fieldType) {
      case "checkbox":
      case "multi_checkbox":
      case "radio":
        element.checked = currentAnswers.value.findIndex((answer) => answer.body == element.value) >= 0
        break
      case "textfield":
        element.value = currentAnswers.value[index].body
        break
    }
  }

  const selects: any[] = answerForm.getElementsByTagName("select") as any
  for (let index = 0; index < selects.length; index++) {
    const element = selects[index]
    switch (props.currentQuestion.fieldType) {
      case "select":
        element.value = currentAnswers.value[index].body
        break
    }
  }

  const textareas: any[] = answerForm.getElementsByTagName("textarea") as any
  for (let index = 0; index < textareas.length; index++) {
    const element = textareas[index]
    switch (props.currentQuestion.fieldType) {
      case "textarea":
        const CKEDITOR = (window as any).CKEDITOR
        element.value = currentAnswers.value[index].body
        if (CKEDITOR) {
          CKEDITOR.replace(element.id, {})
        }
        break
    }
  }
}

const answerQuestion = (): Promise<any> => {
  const answerForm = answerFormRef.value
  if (!answerForm) return Promise.resolve()
  
  const textareas: any[] = answerForm.getElementsByTagName("textarea") as any
  for (let index = 0; index < textareas.length; index++) {
    const element = textareas[index]
    const CKEDITOR = (window as any).CKEDITOR
    element.value = CKEDITOR.instances[element.id].getData()
  }
  const answerData = getFormData(answerForm)
  return updateAnswer({ answer: answerData, questionId: props.currentQuestion.id })
}

const submitExam = () => {
  submit()
}

// Expose methods for parent component access if needed
__expose({
  fillValue,
  answerQuestion,
  submitExam
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        ref_key: "answerFormRef",
        ref: answerFormRef
      }, [
        _createElementVNode("div", { innerHTML: currentQuestionContent.value }, null, 8 /* PROPS */, _hoisted_3)
      ], 512 /* NEED_PATCH */)
    ])
  ]))
}
}

})